import { StyleSheet } from 'react-native';

const ActivityBannerImage = ({ style }) => {
  const oneX = require('./activity-banner.jpg');
  const twoX = require('./activity-banner@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'cover' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { ActivityBannerImage };
